export const filtersDefaultValues = {
  language: "",
  sentiment: "",
  keyword: "",
  start_date: "",
  end_date: "",
  author_verified: "",
};
